import ComponentCard from "../../components/common/ComponentCard";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import UpdateNotification from "../../components/ui/notification/UpdateNotification";
import Notification from "../../components/ui/notification/Notfication";
import CookieConsent from "../../components/ui/notification/CookieConsent";
import PageMeta from "../../components/common/PageMeta";
import { useToast } from "../../contexts/ToastContext";

export default function Notifications() {
  const { success, error, warning, info } = useToast();

  const handleLater = () => {
    alert("Later button clicked");
  };

  const handleUpdate = () => {
    alert("Update Now button clicked");
  };

  const handleCookieSettings = () => {
    alert("Cookie Settings clicked");
  };

  const handleDenyAll = () => {
    alert("Deny All clicked");
  };

  const handleAcceptAll = () => {
    alert("Accept All clicked");
  };

  const handleSuccessToast = () => {
    success("Success!", "Your changes have been saved successfully.");
  };

  const handleErrorToast = () => {
    error("Error!", "Failed to save changes. Please try again.");
  };

  const handleWarningToast = () => {
    warning("Warning!", "This action cannot be undone.");
  };

  const handleInfoToast = () => {
    info("Info", "You have 3 new notifications.");
  };

  return (
    <>
      <PageMeta
        title="React.js  Notifications | TailAdmin - React.js Admin Dashboard Template"
        description="This is React.js Notifications  page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <PageBreadcrumb pageTitle="Notifications" />
      <div className="space-y-5 sm:space-y-6">
        {/* Announcement Banner */}
        <ComponentCard title="Announcement Bar">
          <UpdateNotification
            title="New update! Available"
            message="Enjoy improved functionality and enhancements."
            onLaterClick={handleLater}
            onUpdateClick={handleUpdate}
          />
        </ComponentCard>
        {/* Toast Banner */}
        <ComponentCard title="Toast Notification">
          <CookieConsent
            message="By Clicking on 'Accept', you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts."
            onCookieSettings={handleCookieSettings}
            onDenyAll={handleDenyAll}
            onAcceptAll={handleAcceptAll}
          />
        </ComponentCard>
        {/* Success */}
        <ComponentCard title="Success Notification">
          <Notification variant="success" title="Success! Action Completed!" />
        </ComponentCard>
        {/* Info */}
        <ComponentCard title="Info Notification">
          <Notification variant="info" title="Heads Up! New Information" />
        </ComponentCard>
        {/* Warning */}
        <ComponentCard title="Warning Notification">
          <Notification
            variant="warning"
            title="Alert: Double Check Required"
          />
        </ComponentCard>
        {/* Error */}
        <ComponentCard title="Error Notification">
          <Notification variant="error" title="Something Went Wrong" />
        </ComponentCard>

        {/* Toast System Demo */}
        <ComponentCard title="Toast Notifications (Auto-dismiss)">
          <div className="space-y-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Toast notifications appear in the bottom-right corner and auto-dismiss after 5 seconds. Click the buttons below to test.
            </p>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={handleSuccessToast}
                className="inline-flex items-center justify-center rounded-lg bg-success-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-success-600 transition-colors"
              >
                Show Success Toast
              </button>
              <button
                onClick={handleErrorToast}
                className="inline-flex items-center justify-center rounded-lg bg-error-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-error-600 transition-colors"
              >
                Show Error Toast
              </button>
              <button
                onClick={handleWarningToast}
                className="inline-flex items-center justify-center rounded-lg bg-warning-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-warning-600 transition-colors"
              >
                Show Warning Toast
              </button>
              <button
                onClick={handleInfoToast}
                className="inline-flex items-center justify-center rounded-lg bg-blue-light-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-light-600 transition-colors"
              >
                Show Info Toast
              </button>
            </div>
          </div>
        </ComponentCard>
      </div>
    </>
  );
}
